export default "__VITE_ASSET__93fefdc8__"